import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
	Button,
	Card,
	Typography,
	message,
	Upload,
	Form,
	Affix,
	Space,
	Divider,
	Checkbox,
	Modal,
	Collapse,
	notification
} from 'antd';
import { useSelector } from 'react-redux';
import ProgressBySteps from './ProgressBySteps';
import ModalsDni from './Modal/ModalsDni';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import {
	ArrowLeftOutlined,
	DownOutlined,
	InfoCircleOutlined,
	UpOutlined,
	UserSwitchOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import LoaderLogo from '../components/LoaderLogo';
import Afterbanks from '../AfterBanks/Afterbanks';
import ErrorAfterbanksModal from './Modal/ErrorAfterbanksModal';
import ModalManyThanksDocumentation from './Modal/ModalManyThanksDocumentation';
import { isMobileOnly } from 'react-device-detect';
import IframeResizer from 'iframe-resizer-react';
import { BulbOutlined } from '@ant-design/icons';
import RenderSingFile from '../components/RenderSingFile';
const gibobsLogo = require('../assets/gibobs_logo.png');
const free = require('../assets/ticket-star.png');
const userSwitch = require('../assets/user-switch.png');
import _ from 'lodash';

const { Text } = Typography;

type Props = {
	userMortgageId: any;
	stage: any;
	env: any;
	images: Images;
	setValuesData: any;
	setClickTab: any;
	clickTab: any;
	platform: string;
	traceSadabdell: any;
};

type Images = {
	dataPhotos: any;
	errorModal: any;
	dataBanks: any;
	dataMoreBanks: any;
	psd2: any;
	footerGibobs: any;
	footerMobileDocs: any;
	gifBank: any;
	camera: any;
};

export type ReduxStore = {
	auth: StoreAuth;
};

export type StoreAuth = {
	token: string;
	roles: string;
	operations: any;
};

let count = 0;
export const AutomaticDocumentation = ({
	clickTab,
	setValuesData,
	setClickTab,
	env,
	platform,
	userMortgageId,
	stage,
	traceSadabdell,
	images: {
		dataPhotos,
		errorModal,
		dataBanks,
		dataMoreBanks,
		psd2,
		footerGibobs,
		footerMobileDocs,
		gifBank,
		camera
	}
}: Props) => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
	const userToken = useSelector<ReduxStore, string>((state) => state.auth.token);
	const [nameOperations, setNameOperations] = useState<any>(undefined);
	const [openModals, setOpenModals] = useState(false);
	const [widgetLink, setWidgetLink] = useState<any>(undefined);
	const [stages, setStages] = useState(1);
	const [loading, setLoading] = useState(false);
	const [participants, setParticipants] = useState(1);
	const [guarantors, setGuarantors] = useState(0);
	const [afterBanksVisible, setAfterBanksVisible] = useState(false);
	const [afterBanksVisibleModal, setAfterBanksVisibleModal] = useState(false);
	const [thanksVisibleModal, setThanksVisibleModal] = useState(false);
	const [fileAfterbanks, setFileAfterbanks] = useState<any>(undefined); //upload automatic
	const [stagesAfterBanks, setStagesAfterBanks] = useState(1);
	const [photo, setPhoto] = useState(0);
	const handleFileInput = useRef<any>({});
	const [imageUrl, setImageUrl] = useState(undefined);
	const [saveFileDataField, setSaveFileDataField] = useState([]);
	const { operationId, owner } = useParams<any>();
	const [docSigned, setDocSigned] = useState<any>(undefined);
	const params = useParams<any>();
	const [enviroment, setEnviroment] = useState<any>(undefined);
	const [authorized, setAuthorized] = useState<boolean>(false);
	const [authorizedBankMov, setAuthorizedBankMov] = useState<boolean>(false);

	let dataMortgage = useSelector<any>((state) => state.data.dataSummary);
	dataMortgage = _.find(dataMortgage as any[], (d) => d.operationId === params.operationId);
	const [form] = Form.useForm();
	const [countries, setContries] = useState<any>(undefined);
	const [sabadellSigned, setSabadellSigned] = useState<any>(false);

	let myVar: any = undefined;
	let myVarAf: any = undefined;
	const [completedBankFlip, setCompletedBankFlip] = useState(false);
	const [info, setInfo] = useState<any>(true);
	const [bankflipError, setBankflipError] = useState<boolean>(false);
	const [showModalNextOwner, setShowModalNextOwner] = useState<boolean>(false);

	const PLATFORM_CONFIG: any = {
		gibobs: {
			openCamera: t('doc.openCamera'),
			permissions: t('doc.permissions'),
			icon: <BulbOutlined style={{ fontSize: isMobileOnly ? 14 : 18, color: '#748EA0' }} />,
			color: '#748EA0',
			backgroundColor: 'white',
			minWidth: '100%',
			minHeight: 720,
			imgFormat: 'png'
		},
		engel: {
			openCamera: t('take.photo'),
			permissions: t('doc.permissionsMobile'),
			icon: <InfoCircleOutlined style={{ fontSize: isMobileOnly ? 14 : 18, color: '#666666' }} />,
			color: '#666666',
			backgroundColor: '#FCFAF5',
			minWidth: '95%',
			minHeight: 800,
			imgFormat: 'svg'
		},
		safecredit: {
			openCamera: t('take.photo'),
			permissions: t('doc.permissionsMobile'),
			icon: <InfoCircleOutlined style={{ fontSize: isMobileOnly ? 14 : 18, color: '#505763' }} />,
			color: '#505763',
			backgroundColor: '#F4F4F4',
			minWidth: '95%',
			minHeight: 800,
			imgFormat: 'svg'
		},
		sabadell: {
			minWidth: '100%',
			minHeight: 800
		}
	};

	useEffect(() => {
		getDataOperation();
		if (stages === 1 && platform === 'sabadell') {
			traceSadabdell(
				stages === 1 ? 'paso dni' : 'conexion datos',
				i18n.language === 'cat' ? 'ca' : 'es'
			);
		}

		axios.get(`${env.api.url}/v1/countries`).then((response) => {
			setContries(response.data.data);
		});

		if (env.api.url === 'https://dev.api.gibobs.net') {
			setEnviroment('dev');
		} else if (env.api.url === 'https://staging.api.gibobs.net') {
			setEnviroment('staging');
		} else {
			setEnviroment('prod');
		}
	}, []);

	useEffect(() => {
		getDocuments(owner);
		const currentOwnerNumber = parseInt(owner.replace('owner', ''), 10);
		if (platform === 'sabadell' && currentOwnerNumber > 1) {
			setShowModalNextOwner(true);
		}
	}, [owner]);

	useEffect(() => {
		if (showModalNextOwner) {
			const timeout = setTimeout(() => {
				setShowModalNextOwner(false);
			}, 3000);

			return () => clearTimeout(timeout);
		}
	}, [showModalNextOwner]);

	useEffect(() => {
		if (widgetLink && stages === 2) {
			if (completedBankFlip) {
				clearInterval(myVar);
			}
			myVar = setInterval(() => {
				getBankFlipProcess();
			}, 2000);
		}
		if (stages === 2 && platform === 'sabadell') {
			traceSadabdell('conexion datos', i18n.language === 'cat' ? 'ca' : 'es');
		}
	}, [widgetLink && stages === 2]);

	useEffect(() => {
		if (stages === 3 && stagesAfterBanks === 1 && platform === 'sabadell') {
			traceSadabdell(
				stagesAfterBanks === 1 ? 'movimientos bancarios' : 'movimientos bancarios listado',
				i18n.language === 'cat' ? 'ca' : 'es'
			);
		}
		if (stages === 3 && stagesAfterBanks === 2 && platform === 'sabadell') {
			traceSadabdell(
				'movimientos bancarios listado',
				i18n.language === 'cat' ? 'ca' : 'es',
				i18n.language === 'cat' ? 'ca' : 'es'
			);
		}
		if (stages === 3 && platform !== 'sabadell') {
			if (afterBanksVisible) {
				clearInterval(myVarAf);
			}
			myVarAf = setInterval(() => {
				getDocuments(owner);
			}, 2000);
		}

		return () => {
			clearInterval(myVarAf);
		};
	}, [stages]);

	const changeCount = () => {
		count = 1;
	};

	const handleClick = () => {
		handleFileInput.current.click();
	};

	async function encodeFileAsBase64URL(file: any) {
		return new Promise((resolve) => {
			const reader = new FileReader();
			reader.addEventListener('loadend', () => {
				resolve(reader.result);
			});
			reader.readAsDataURL(file);
		});
	}

	const handleUploadFile = (file: any) => {
		setLoading(true);
		setSaveFileDataField([]);
		axios
			.put(
				`${env.api.url}/v1/documents/operation/attachment`,
				{
					operationId: operationId,
					file: file[0].file,
					fileName: file[0].fileName,
					owner: owner,
					type: 'nif',
					page: 't'
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				setImageUrl(response.data.data);
				message.success(t('doc.dniSuccess'));
				setLoading(false);
				if (photo === 0) {
					setPhoto(1);
				} else if (photo === 1) {
					setStages(2);
					callToBankFlip();
				}
			})
			.catch((error) => console.log(error));
	};

	const saveFileData = (file: any, name: any) => {
		const documentFile = saveFileDataField;
		documentFile.push({
			file,
			fileName: name
		});
		setSaveFileDataField(documentFile);
		handleUploadFile(documentFile);
	};

	const handleImageChange = async (event: any) => {
		const base64URL = await encodeFileAsBase64URL(event.target.files[0]);
		let tmpImg = undefined;
		tmpImg = (base64URL as string).split(',')[1];
		saveFileData(tmpImg, 'dni');
	};

	const getBankFlipProcess = () => {
		axios
			.get(
				`${env.api.url}/docs/bankflip/check-provider-reference/${widgetLink.providerReferences.id}`,
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				if (response.data.data.data.flags.sessionCompleted) {
					setAfterBanksVisible(false);
					setStagesAfterBanks(1);
					if (platform === 'sabadell') {
						setStages(3);
					}
					if (platform === 'gibobs' || platform === 'engel' || platform === 'safecredit') {
						//paso 3 elinado
						checkNextStep();
					}

					setFileAfterbanks(false);
					setCompletedBankFlip(true);
					clearInterval(myVar);
					setWidgetLink(undefined);
				}
			})
			.catch((error) => {});
	};

	const getDocuments = async (owner: any) => {
		const response = await axios.get(
			`${env.api.url}/v1/documents/get-operation-documents/${operationId}`,
			{
				headers: { Authorization: `Bearer ${userToken}` }
			}
		);
		let tempFileAfterbanks = [];
		tempFileAfterbanks = response.data.data.filter(
			(item: any) =>
				item.tags.includes('automatic') && item.type === 'bankreader' && item.owner === owner
		);
		const tmpConsent_sabadell = response.data.data.some(
			(item: any) => item.type === 'consent_sabadell' && item.owner === owner
		);

		if (tmpConsent_sabadell && platform === 'sabadell' && stages < 2) {
			setStages(2);
		}

		if (tempFileAfterbanks.length !== 0 && count === 0) {
			setAfterBanksVisible(false);
			setStagesAfterBanks(3);
			setFileAfterbanks(tempFileAfterbanks);
		}
		if (tempFileAfterbanks.length !== 0 && count === 1) {
			setAfterBanksVisible(true);
			//setStagesAfterBanks(3);
			setFileAfterbanks(tempFileAfterbanks);
		}
	};

	const getDataOperation = () => {
		axios
			.get(`${env.api.url}/v1/operations/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setGuarantors(response?.data?.data?.operationData?.mortgage?.guarantors);
				setNameOperations(response.data.data);
				setParticipants(response?.data?.data?.operationData?.mortgage?.participants);
			})
			.catch((error) => {});
	};

	const callToBankFlip = () => {
		setLoading(true);
		axios
			.post(
				`${env.api.url}/docs/bankflip/create-session`,
				{
					operationId: operationId,
					personKey: owner
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				setLoading(false);
				setWidgetLink(response.data.data);
			});
	};

	const documentTabs = [];

	for (let i = 1; i <= participants; i++) {
		documentTabs.push(`owner${i}`);
	}

	for (let i = 1; i <= guarantors; i++) {
		documentTabs.push(`guarantor${i}`);
	}

	const checkNextStep = () => {
		clearInterval(myVarAf);
		if (participants > 1 && owner === 'owner1') {
			navigate(`/${operationId}/owner2/automatic-documentation`);
			setStages(1);
			setStagesAfterBanks(1);
		} else {
			navigate(`/operations/${operationId}/documents`);
		}
		// if (owner !== documentTabs[documentTabs.length - 1]) {
		// 	navigate(
		// 		`/${operationId}/${documentTabs[documentTabs.indexOf(owner) + 1]}/automatic-documentation`
		// 	);
		// 	setStages(1);
		// } else {
		// 	navigate(`/operations/${operationId}/documents`);
		// }
	};

	const clearInformation = () => {
		count = 0;
		clearInterval(myVarAf);
	};

	const renderHeader = () => {
		switch (platform) {
			case 'gibobs':
				return (
					<div
						className="wrapper-flex"
						style={{
							marginBottom: 10,
							marginTop: platform !== 'sabadell' && 16,
							zIndex: 999,
							cursor: 'pointer',
							position: 'relative',
							display: 'flex',
							alignItems: 'center'
						}}
						onClick={() => {
							navigate(`/operations/${operationId}/documents`);
						}}>
						<ArrowLeftOutlined />
						<div className="owner-title-documentation">{t(`mydocuments.${owner}`)}</div>
					</div>
				);
			case 'sabadell':
				return (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							width: '100%',
							padding: isMobileOnly && 10
						}}>
						<Space>
							<ArrowLeftOutlined
								style={{ cursor: 'pointer' }}
								onClick={() => {
									navigate(`/operations/${operationId}/documents`);
								}}
							/>
							{!isMobileOnly && (
								<div className="owner-title-documentation">{t(`mydocuments.${owner}`)}</div>
							)}
						</Space>
						{isMobileOnly && stages !== 1 && (
							<Text
								onClick={() => {
									if (stages === 1) {
										setStages(2);
									} else if (stages === 2) {
										setStages(3);
									} else {
										checkNextStep();
										clearInterval(myVar);
									}
								}}
								style={{
									fontSize: 14,
									fontWeight: 400,
									color: '#212121',
									cursor: 'pointer'
								}}>
								{t('minVersion.Skip')}
							</Text>
						)}
					</div>
				);
			case 'engel':
				return (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							width: '100%',
							marginTop: isMobileOnly && 20,
							padding: isMobileOnly && 10
						}}>
						<ArrowLeftOutlined
							style={{ cursor: 'pointer' }}
							onClick={() => {
								navigate(`/operations/${operationId}/documents`);
							}}
						/>
						<Text
							onClick={() => {
								if (stages === 1) {
									setStages(2);
									callToBankFlip();
								} else {
									checkNextStep();
									clearInterval(myVar);
								}
							}}
							style={{
								fontSize: 14,
								fontWeight: 400,
								color: '#262626',
								textDecoration: platform !== 'sabadell' && 'underline',
								cursor: 'pointer'
							}}>
							{t('minVersion.Skip')}
						</Text>
					</div>
				);
			case 'safecredit':
				return (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							width: '100%',
							marginTop: isMobileOnly && 20,
							padding: isMobileOnly && 10
						}}>
						<img
							src="/images/documents/arrowleft.svg"
							alt="Arrow Left"
							onClick={() => {
								navigate(`/operations/${operationId}/documents`);
							}}
							style={{ cursor: 'pointer' }}
						/>
						<Text
							onClick={() => {
								if (stages === 1) {
									setStages(2);
									callToBankFlip();
								} else {
									checkNextStep();
									clearInterval(myVar);
								}
							}}
							style={{
								fontSize: 14,
								fontWeight: 400,
								color: '#000000',
								textDecoration: 'underline',
								cursor: 'pointer'
							}}>
							{t('minVersion.Skip')}
						</Text>
					</div>
				);
			default:
				return null;
		}
	};

	const renderSign = () => {
		return (
			<div>
				<div>
					<div
						style={{ display: 'flex', justifyContent: 'center', marginTop: 24, marginBottom: 20 }}>
						<RenderSingFile
							setDocSigned={setDocSigned}
							nameBank={'consent_sabadell'}
							dataMortgage={dataMortgage && dataMortgage}
							clickTab={owner}
							form={form}
							countries={countries}
							sabadellSigned={sabadellSigned}
							setSabadellSigned={setSabadellSigned}
							platform={platform}
						/>
					</div>
				</div>
				<div>
					{!isMobileOnly && (
						<Button
							onClick={() => sendSign()}
							onKeyDown={(e) => {
								if (e.key === 'Enter' || e.key === ' ') {
									e.preventDefault();
									sendSign();
								}
							}}
							disabled={sabadellSigned ? false : true}
							className={'button-primari-gibobs'}
							style={{ paddingLeft: 24, paddingRight: 24 }}
							type="primary">
							{t('offers.accept')}
						</Button>
					)}
					{isMobileOnly && (
						<div
							style={{
								position: 'fixed',
								bottom: 0,
								left: 0,
								width: '100%',
								padding: '12px 16px',
								zIndex: 1000,
								display: 'flex',
								flexDirection: 'column',
								gap: '8px',
								background: 'white'
							}}>
							<Button
								onClick={() => sendSign()}
								disabled={sabadellSigned ? false : true}
								className={'button-primari-gibobs'}
								type="primary">
								{t('offers.accept')}
							</Button>
						</div>
					)}
				</div>
			</div>
		);
	};

	const signFile = () => {
		axios
			.post(
				`${env.api.url}/docs/documents/sign-document`,
				{
					operationId: params.operationId,
					owner: owner,
					consentCheck: sabadellSigned,
					typeDocument: 'consent_sabadell'
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				setStages(2);
			});
	};

	const sendSign = () => {
		form
			.validateFields()
			.then((values) => {
				let data = [
					{
						key: owner,
						subkey: 'name',
						value: values.name
					},
					{
						key: owner,
						subkey: 'firstSurname',
						value: values.firstSurname
					},
					{
						key: owner,
						subkey: 'lastSurname',
						value: values.lastSurname
					},
					{
						key: owner,
						subkey: 'nif',
						value: values.nif
					}
				];

				if (values.nif?.includes('**')) {
					data = data.filter((item) => item.subkey !== 'nif');
				}
				if (values?.email?.includes('**')) {
					data = data.filter((item) => item.subkey !== 'email');
				}
				if (values?.phone?.includes('**')) {
					data = data.filter((item) => item.subkey !== 'phone');
				}

				axios
					.post(
						`${env.api.url}/v1/mortgages/data/multiple/update/${params.operationId}`,
						{ values: data },
						{ headers: { Authorization: `Bearer ${userToken}` } }
					)
					.then((response) => {
						if (response.data.success) {
							form.resetFields();
							signFile();
						} else {
							message.error(t('m_common.requestErrorTitle'));
						}
					});
			})
			.catch((errors) => {
				console.error('Errores de validación:', errors);
			});
	};

	const renderStage1Desktop = () => {
		switch (platform) {
			case 'sabadell':
				const currentOwnerNumber = parseInt(owner.replace('owner', ''), 10);
				return (
					<>
						{loading && (
							<div
								style={{
									textAlign: 'center',
									height: '50vh',
									backgroundColor: 'white'
								}}>
								<LoaderLogo />
							</div>
						)}
						{currentOwnerNumber > 1 && (
							<Modal
								centered
								open={showModalNextOwner}
								onCancel={() => setShowModalNextOwner(false)}
								className={isMobileOnly ? 'ModalCommonSmall ModalDoc' : 'ModalCommon'}
								footer={null}
								title={`${t('owner.doc')} ${currentOwnerNumber}`}
								afterClose={() => {
									axios
										.post(
											`${env.api.url}/v1/mortgages/data/update/${operationId}`,
											{
												participant: owner,
												key: 'viewModalsAutomatic',
												value: true
											},
											{ headers: { Authorization: `Bearer ${userToken}` } }
										)
										.then(() => {
											setShowModalNextOwner(false);
										});
								}}>
								<div style={{ marginTop: -36, paddingBottom: 40 }}>
									{t('owner.finish')} {currentOwnerNumber - 1}.<br />
									{t('owner.repeat')} {currentOwnerNumber}.
								</div>
							</Modal>
						)}
						<div style={{ marginTop: 32 }}>
							<iframe
								title="Documento de tratamiendo de datos para Banco Sabadell"
								src={`https://gibobs-${enviroment}-cdn.s3.eu-central-1.amazonaws.com/consent-documents/consent-sabadell.pdf`}
								style={{ height: 700, width: '80%', border: 'none' }}></iframe>
						</div>
						<div
							style={{
								width: '100%',
								display: 'flex',
								justifyContent: 'center',
								marginBottom: 300,
								marginTop: 32
							}}>
							{renderSign()}
						</div>
					</>
				);
			case 'gibobs':
			case 'engel':
			case 'safecredit':
				return (
					<>
						<div style={{ marginBottom: 32 }}>
							<div
								className="need-documents-title"
								dangerouslySetInnerHTML={{
									__html: t('doc.needDocumentsOwners', { owner: t(`mydocuments.${owner}`) })
								}}
							/>
							<div style={{ marginBottom: 12 }}>
								<img
									src={`/images/documents/dni_delantera.${PLATFORM_CONFIG[platform].imgFormat}`}
									alt="DNI Front"
								/>
								<img
									src={`/images/documents/dni_trasera.${PLATFORM_CONFIG[platform].imgFormat}`}
									alt="DNI Back"
									style={{ marginLeft: 16 }}
								/>
							</div>
							<div
								style={{
									marginTop: 8,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									gap: 8
								}}>
								{PLATFORM_CONFIG[platform].icon}
								<Text
									style={{
										fontSize: 14,
										fontWeight: 400,
										color: PLATFORM_CONFIG[platform].color,
										textAlign: 'center'
									}}>
									{PLATFORM_CONFIG[platform].permissions}
								</Text>
							</div>
						</div>
						<div>
							{platform === 'gibobs' && (
								<Button
									className="button-secundary-gibobs"
									style={{ marginRight: 8 }}
									type="dashed"
									onClick={() => {
										setStages(2);
										callToBankFlip();
									}}>
									{platform === 'gibobs' ? t('doc.attachDNI') : t('modalDocuments2.bottonNo')}
								</Button>
							)}
							<Button
								onClick={() => setOpenModals(true)}
								className={'button-primari-gibobs'}
								style={{ paddingLeft: 24, paddingRight: 24 }}
								type="primary">
								{t('take.photo')}
							</Button>
						</div>
					</>
				);

			default:
				return null;
		}
	};

	const renderStage1Mobile = () => {
		switch (platform) {
			case 'sabadell':
				const currentOwnerNumber = parseInt(owner.replace('owner', ''), 10);
				return (
					<>
						{loading && (
							<div
								style={{
									textAlign: 'center',
									height: '50vh',
									backgroundColor: 'white'
								}}>
								<LoaderLogo />
							</div>
						)}
						{currentOwnerNumber > 1 && (
							<Modal
								centered
								open={showModalNextOwner}
								onCancel={() => setShowModalNextOwner(false)}
								className={isMobileOnly ? 'ModalCommonSmall' : 'ModalCommon'}
								footer={null}
								title={`${t('owner.doc')} ${currentOwnerNumber}`}
								afterClose={() => {
									axios
										.post(
											`${env.api.url}/v1/mortgages/data/update/${operationId}`,
											{
												participant: owner,
												key: 'viewModalsAutomatic',
												value: true
											},
											{ headers: { Authorization: `Bearer ${userToken}` } }
										)
										.then(() => {
											setShowModalNextOwner(false);
										});
								}}>
								<div style={{ marginTop: -36, paddingBottom: 40 }}>
									{t('owner.finish')} {currentOwnerNumber - 1}.<br />
									{t('owner.repeat')} {currentOwnerNumber}.
								</div>
							</Modal>
						)}
						<div style={{ marginTop: 32 }}>
							<iframe
								title="Documento de tratamiendo de datos para Banco Sabadell"
								src={`https://gibobs-${enviroment}-cdn.s3.eu-central-1.amazonaws.com/consent-documents/consent-sabadell.pdf`}
								style={{ height: 700, width: '80%', border: 'none' }}></iframe>
						</div>
						<div
							style={{
								width: '100%',
								display: 'flex',
								justifyContent: 'center',
								marginBottom: 100,
								marginTop: 32
							}}>
							{renderSign()}
						</div>
					</>
				);
			case 'gibobs':
			case 'engel':
			case 'safecredit':
				return (
					<>
						<div
							className="need-documents-title"
							style={{ marginBottom: 16 }}
							dangerouslySetInnerHTML={{
								__html:
									photo > 0
										? t('doc.dniBack', { owner: t(`mydocuments.${owner}`) })
										: t('doc.dniFront', { owner: t(`mydocuments.${owner}`) })
							}}></div>
						<div
							style={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
								height: '50vh'
							}}>
							<img
								src={
									photo > 0
										? `/images/documents/dni_delantera.${PLATFORM_CONFIG[platform].imgFormat}`
										: `/images/documents/dni_trasera.${PLATFORM_CONFIG[platform].imgFormat}`
								}
								alt="Imagen DNI"
							/>
							<div
								style={{
									margin: 24,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									gap: 8
								}}>
								{PLATFORM_CONFIG[platform].icon}
								<Text
									style={{
										fontSize: 10,
										fontWeight: 400,
										color: PLATFORM_CONFIG[platform].color,
										textAlign: isMobileOnly ? 'left' : 'center'
									}}>
									{PLATFORM_CONFIG[platform].permissions}
								</Text>
							</div>
						</div>
						<div
							style={{
								position: 'fixed',
								width: '100%',
								bottom: 16,
								left: 0,
								padding: 16,
								zIndex: 999
							}}>
							<input
								type="file"
								accept="image/jpeg"
								capture="environment"
								style={{ display: 'none' }}
								ref={handleFileInput}
								onChange={handleImageChange}
							/>
							<Button
								className="button-primari-gibobs"
								type="primary"
								style={{ width: '100%', height: 40 }}
								onClick={handleClick}>
								{PLATFORM_CONFIG[platform].openCamera}
							</Button>

							{platform === 'gibobs' && (
								<Button
									style={{
										color: '#02C3CD',
										borderColor: '#fff',
										width: '100%',
										boxShadow: 'none',
										borderRadius: 8
									}}
									onClick={() => {
										setStages(2);
										callToBankFlip();
									}}>
									{t('doc.attachDNI')}
								</Button>
							)}
						</div>
					</>
				);
			default:
				return null;
		}
	};

	const UploadPanelHeader = () => {
		return (
			<Space>
				<img
					src={free}
					alt="ticket"
					style={{
						height: 24,
						width: 'auto',
						verticalAlign: 'middle',
						flexShrink: 0
					}}
				/>
				<div
					style={{
						display: 'flex',
						flexDirection: isMobileOnly ? 'column' : 'row',
						alignItems: isMobileOnly ? 'flex-start' : 'center',
						gap: isMobileOnly ? 0 : 8
					}}>
					<Text
						style={{
							fontSize: isMobileOnly ? 14 : 16,
							fontWeight: 700
						}}>
						{t('service.free')}
					</Text>
					<Text
						style={{
							fontSize: isMobileOnly ? 14 : 16,
							fontWeight: 500,
							textAlign: 'left'
						}}>
						{t('upload.manually')}
					</Text>
				</div>
			</Space>
		);
	};

	const handleRedirect = () => {
		setInfo(false);
		axios
			.post(
				`${env.api.url}/v1/mortgages/data/update/${operationId}`,
				{
					key: 'checkOpendata',
					participant: owner,
					value: authorized
				},
				{ headers: { Authorization: `Bearer ${userToken}` } }
			)
			.then(() => {
				axios
					.get(`${env.api.url}/docs/sabadell/session/BANKFLIP/${owner}/${operationId}`, {
						headers: { Authorization: `Bearer ${userToken}` }
					})
					.then((res) => {
						if (res.data.data.includes('error')) {
							setTimeout(() => {
								setInfo(true);
								setBankflipError(true);
							}, 3000);
						} else {
							setTimeout(() => {
								window.location.href = res.data.data;
							}, 3000);
						}
					})
					.catch((err) => {
						console.error('Se ha producido un error: ', err);
						message.error('Se ha producido un error');
					});
			});
	};

	return (
		<div style={{ padding: isMobileOnly ? 10 : 20, textAlign: 'center' }}>
			{renderHeader()}
			<ProgressBySteps
				steps={platform !== 'sabadell' ? 2 : 3}
				stage={stages}
				env={env}
				platform={platform}
			/>
			{stages === 1 && (
				<>
					{loading ? (
						<div
							style={{
								textAlign: 'center',
								height: '50vh',
								backgroundColor: PLATFORM_CONFIG[platform].backgroundColor
							}}>
							<LoaderLogo />
						</div>
					) : (
						<>{isMobileOnly ? renderStage1Mobile() : renderStage1Desktop()}</>
					)}
				</>
			)}

			{/* Para sabadell el paso 2 es DNI y el paso 3 es bankflip, para los demás el paso 2  es bankflip */}
			{stages === 2 && platform === 'sabadell' && (
				<div
					style={{
						width: '100%',
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center'
					}}>
					{loading ? (
						<div
							style={{
								textAlign: 'center',
								height: '50vh',
								backgroundColor: 'white'
							}}>
							<LoaderLogo />
						</div>
					) : (
						<>
							<Space direction="vertical" style={{ marginTop: 16, gap: 24 }}>
								<div
									style={{ color: '#212121' }}
									dangerouslySetInnerHTML={{
										__html: t('doc.needDocumentsOwners', { owner: t(`mydocuments.${owner}`) })
									}}
								/>
								<Space
									direction={isMobileOnly ? 'vertical' : 'horizontal'}
									size={isMobileOnly ? 'small' : 'large'}>
									<img
										src={'/images/DNI_front.svg'}
										alt="DNI_front"
										style={{ width: 300, height: 'auto' }}
									/>
									<img
										src={'/images/DNI_back.svg'}
										alt="DNI_back"
										style={{ width: 300, height: 'auto' }}
									/>
								</Space>
							</Space>
							{!isMobileOnly && (
								<Space direction="vertical" style={{ marginTop: 32 }}>
									<Button
										onClick={() => setOpenModals(true)}
										className={'button-primari-gibobs'}
										style={{ width: 200 }}
										type="primary">
										{t('take.sabadellPhoto')}
									</Button>
									<Button
										className="button-text"
										style={{ color: '#004799' }}
										type="text"
										onClick={() => {
											setStages(3);
										}}>
										{t('upload.later')}
									</Button>
									<div style={{ width: 600, textAlign: 'left', marginTop: 16 }}>
										<Text style={{ fontSize: 12, color: '#424242' }}>{t('downloadDNI.after')}</Text>
									</div>
								</Space>
							)}
							{isMobileOnly && (
								<div style={{ marginTop: 16, maxWidth: 300 }}>
									<Text style={{ fontSize: 12, color: '#757575' }}>{t('downloadDNI.after')}</Text>
									<div
										style={{
											position: 'fixed',
											bottom: 0,
											left: 0,
											width: '100%',
											padding: '12px 16px',
											zIndex: 1000,
											display: 'flex',
											flexDirection: 'column',
											gap: '8px',
											background: 'white'
										}}>
										<Button
											onClick={() => setOpenModals(true)}
											className="button-primari-gibobs"
											type="primary">
											{t('init.continueButton')}
										</Button>
									</div>
								</div>
							)}
						</>
					)}
				</div>
			)}

			{stages === 2 && platform !== 'sabadell' && (
				<div style={{ marginBottom: 200 }}>
					{loading && widgetLink?.widgetLink !== undefined ? (
						<div
							style={{
								textAlign: 'center',
								height: '50vh',
								backgroundColor: PLATFORM_CONFIG[platform].backgroundColor
							}}>
							<LoaderLogo />
						</div>
					) : (
						<>
							<IframeResizer
								log
								src={widgetLink?.widgetLink}
								style={{
									width: '1px',
									minWidth: PLATFORM_CONFIG[platform].minWidth,
									border: 'none',
									minHeight: PLATFORM_CONFIG[platform].minHeight,
									marginTop: !isMobileOnly && -50
								}}
								checkOrigin={['https://bkfp.io', 'https://widget.bankflip.io']}
								heightCalculationMethod="lowestElement"
								inPageLinks
							/>
							{widgetLink?.widgetLink && (
								<div style={{ marginTop: isMobileOnly ? 0 : 8 }}>
									{(platform === 'gibobs' || platform === 'sabadell') && (
										<Button
											style={{
												border: isMobileOnly && 'none',
												boxShadow: isMobileOnly && undefined
											}}
											className="button-secundary-gibobs"
											type="dashed"
											onClick={() => {
												if (platform === 'sabadell') {
													setStages(3);
												}
												if (platform === 'gibobs') {
													checkNextStep();
													//paso 3 elinado
												}
												clearInterval(myVar);
											}}>
											{platform === 'gibobs' ? t('doc.attachDNI') : t('modalDocuments2.bottonNo')}
										</Button>
									)}
								</div>
							)}
						</>
					)}
				</div>
			)}

			{stages === 3 && platform === 'sabadell' && (
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center'
					}}>
					{info && bankflipError && (
						<Space
							direction="vertical"
							size={'large'}
							style={{ maxWidth: isMobileOnly ? 300 : 550 }}>
							<img
								src={userSwitch}
								alt="user logo"
								style={{ height: 60, width: 'auto', marginTop: 24 }}
							/>
							<Text
								style={{
									fontSize: isMobileOnly ? 16 : 20,
									fontWeight: 600,
									color: '#BE0028'
								}}>
								{t('error.ocurred')}
							</Text>
							{!isMobileOnly && (
								<div>
									<Button
										className="button-secundary-gibobs"
										style={{
											backgroundColor: '#f5f5f5',
											color: '#004799',
											borderColor: '#004799',
											boxShadow: undefined,
											width: 200
										}}
										type="dashed"
										onClick={() => {
											checkNextStep();
										}}>
										{t('upload.later')}
									</Button>
									<Button
										onClick={handleRedirect}
										disabled={!authorized}
										className={'button-primari-gibobs'}
										style={{ paddingLeft: 24, paddingRight: 24, marginLeft: 8, width: 200 }}
										type="primary">
										{t('try.again')}
									</Button>
									<div style={{ width: 780, textAlign: 'left', marginTop: 16 }}>
										<Text style={{ fontSize: 12, color: '#424242' }}>{t('error.exists')}</Text>
									</div>
								</div>
							)}
							{isMobileOnly && (
								<div style={{ maxWidth: 300, textAlign: 'left' }}>
									<Text style={{ fontSize: 12, color: '#424242' }}>
										{t('download.afterBankTitle6')}
									</Text>
									<div
										style={{
											position: 'fixed',
											bottom: 0,
											left: 0,
											width: '100%',
											padding: '12px 16px',
											zIndex: 1000,
											display: 'flex',
											flexDirection: 'column',
											gap: '8px',
											background: 'white'
										}}>
										<Button
											className="button-primari-gibobs"
											type="primary"
											onClick={handleRedirect}
											disabled={!authorized}>
											{t('try.again')}
										</Button>
									</div>
								</div>
							)}
						</Space>
					)}
					{info && !bankflipError && (
						<div
							style={{
								margin: '24px auto',
								display: 'flex',
								alignItems: 'center',
								flexDirection: 'column',
								gap: isMobileOnly ? 16 : 24,
								color: '#212121',
								maxWidth: isMobileOnly ? 'none' : 820
							}}>
							<Text style={{ fontSize: 16, fontWeight: 700 }}>{t('save.time')}</Text>
							<Space style={{ textAlign: 'left' }}>
								<img src={gibobsLogo} alt="logo gibobs" style={{ height: 40, width: 'auto' }} />
								<Divider
									type="vertical"
									style={{ borderColor: '#424242', margin: 0, height: 40 }}
								/>
								<Text style={{ fontSize: isMobileOnly ? 12 : 14 }}>{t('get.documentedInfo')}</Text>
							</Space>
							<Collapse
								expandIcon={({ isActive }) =>
									isActive ? (
										<UpOutlined style={{ color: '#757575' }} />
									) : (
										<DownOutlined style={{ color: '#757575' }} />
									)
								}
								expandIconPosition="end"
								items={[
									{
										key: '1',
										label: <UploadPanelHeader />,
										children: (
											<Space direction="vertical" style={{ gap: 16 }}>
												<Text>{t('upload.twoEasyWays')}</Text>
												<Text>{t('upload.stepAttachManually')}</Text>
												<Text>{t('upload.stepAuthorizeThirdParty')}</Text>
											</Space>
										),
										className: 'automatic-doc-collapse'
									}
								]}
							/>
							<Checkbox onChange={() => setAuthorized(!authorized)} defaultChecked={authorized}>
								<Text style={{ fontSize: isMobileOnly ? 12 : 14 }}>
									{t('authorize.transferData')}
								</Text>
							</Checkbox>
							{!isMobileOnly && (
								<Space direction="vertical" style={{ alignItems: 'center' }}>
									<Button
										onClick={handleRedirect}
										disabled={!authorized}
										className={'button-primari-gibobs'}
										style={{ paddingLeft: 24, paddingRight: 24, marginLeft: 8, width: 200 }}
										type="primary">
										{t('download.withGibobs')}
									</Button>
									<Button
										className="button-text"
										type="text"
										style={{ marginLeft: 6, color: '#004799' }}
										onClick={() => {
											checkNextStep();
										}}>
										{t('authorize.manualUploadSelected')}
									</Button>
									<Space
										direction="vertical"
										style={{ width: 780, textAlign: 'left', marginTop: 16 }}>
										<a
											href="https://www.gibobs.com/seguridad/?_gl=1*1maiyrz*_gcl_au*MTA1Nzk2MTk0MS4xNzU2MzcyMjQ2LjIxNDI2NTQzMDYuMTc1OTE1ODA1OS4xNzU5MTU4MDYw"
											target="_blank"
											style={{ fontWeight: 600, textDecoration: 'underline', color: '#212121' }}>
											{t('gibobs.learnAboutServices')}
										</a>
										<Text style={{ fontSize: 12, color: '#424242' }}>
											{t('download.afterBankTitle6')}
										</Text>
									</Space>
								</Space>
							)}
							{isMobileOnly && (
								<div style={{ maxWidth: 300, textAlign: 'left' }}>
									<Space direction="vertical">
										<a
											href="https://www.gibobs.com/seguridad/?_gl=1*1maiyrz*_gcl_au*MTA1Nzk2MTk0MS4xNzU2MzcyMjQ2LjIxNDI2NTQzMDYuMTc1OTE1ODA1OS4xNzU5MTU4MDYw"
											target="_blank"
											style={{ fontWeight: 600, textDecoration: 'underline', color: '#212121' }}>
											{t('gibobs.learnAboutServices')}
										</a>
										<Text style={{ fontSize: 12, color: '#424242' }}>
											{t('download.afterBankTitle6')}
										</Text>
									</Space>
									<div
										style={{
											position: 'fixed',
											bottom: 0,
											left: 0,
											width: '100%',
											padding: '12px 16px',
											zIndex: 1000,
											display: 'flex',
											flexDirection: 'column',
											gap: '8px',
											background: 'white'
										}}>
										<Button
											className="button-primari-gibobs"
											type="primary"
											onClick={handleRedirect}
											disabled={!authorized}>
											{t('download.withGibobs')}
										</Button>
										<Button
											className="button-text"
											type="text"
											onClick={() => {
												checkNextStep();
											}}>
											{t('authorize.manualUploadSelected')}
										</Button>
									</div>
								</div>
							)}
						</div>
					)}
					{info === false && (
						<div style={{ marginTop: 24, maxWidth: 300 }}>
							<Text style={{ fontSize: 20, fontWeight: 600, color: '#212121' }}>
								{t('redirecting.gibobs')}
							</Text>
							<LoaderLogo />
						</div>
					)}
				</div>
			)}

			{/* Paso 3 (afterbanks) eliminado para todas menos sabadell*/}
			{/* {stages === 3 && platform !== 'sabadell' && stagesAfterBanks === 1 && (
				<div style={{ marginBottom: 200 }}>
					<div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
						<div
							style={{
								width: platform === 'sabadell' ? undefined : 500,
								textAlign: platform === 'sabadell' ? undefined : 'left',
								marginBottom: -5
							}}
							className="need-documents-title"
							dangerouslySetInnerHTML={{
								__html: t('doc.bankMovementsDescriptionGibobs')
							}}
						/>
					</div>
					<div
						style={{
							width: '100%',
							justifyContent: 'center',
							display: 'flex',
							marginBottom: 24
						}}>
						<Card className="gb-card-banks-onboarding" style={{ width: 552 }}>
							<div style={{ display: 'flex' }}>
								<img src={psd2} alt="psd2" style={{ height: 48, width: 48 }}></img>
								<div style={{ marginLeft: 8 }}>
									<Text style={{ color: '#2F4858', fontSize: 14, fontWeight: 400 }}>
										{t('doc.bankMovementsDescriptionGibobs1')}
									</Text>
									&nbsp;
									<Text style={{ color: '#2F4858', fontSize: 14, fontWeight: 600 }}>
										{t('doc.bankMovementsDescriptionGibobs2')}
									</Text>
								</div>
							</div>
						</Card>
					</div>
					<div style={{ display: 'flex', justifyContent: 'center', overflow: 'hidden' }}>
						<img src={dataBanks} alt="dataBanks" height={isMobileOnly ? 200 : 300} />
					</div>
					{!isMobileOnly && (
						<div style={{}}>
							<Button
								className="button-secundary-gibobs"
								style={{ marginRight: 8 }}
								type="dashed"
								onClick={() => {
									clearInterval(myVarAf);
									checkNextStep();
								}}>
								{t('modalDocuments2.bottonNo')}
							</Button>
							<Button
								onClick={() => {
									setAfterBanksVisible(true);
									setStagesAfterBanks(2);
								}}
								className="button-primari-gibobs"
								style={{ width: 200 }}
								type="primary">
								{t('init.continueButton')}
							</Button>
						</div>
					)}
					{isMobileOnly && (
						<div
							style={{
								position: 'fixed',
								bottom: 0,
								left: 0,
								width: '100%',
								padding: '12px 16px',
								zIndex: 1000,
								display: 'flex',
								flexDirection: 'column',
								gap: '8px'
							}}>
							<Button
								onClick={() => {
									setAfterBanksVisible(true);
									setStagesAfterBanks(2);
								}}
								className="button-primari-gibobs"
								type="primary">
								{t('init.continueButton')}
							</Button>
							<Button
								className="button-secundary-gibobs"
								style={{
									marginRight: 8,
									border: 'none',
									backgroundColor: platform === 'gibobs' ? '#FAFEFE' : '#f5f5f5',
									boxShadow: undefined
								}}
								type="dashed"
								onClick={() => {
									clearInterval(myVarAf);
									checkNextStep();
								}}>
								{t('modalDocuments2.bottonNo')}
							</Button>
						</div>
					)}
				</div>
			)}
			{stages === 3 && platform !== 'sabadell' && stagesAfterBanks === 2 && (
				<div style={{ marginBottom: 200 }}>
					{platform !== 'sabadell' && !isMobileOnly && (
						<>
							<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
								<img src={gifBank} alt="asdf" style={{ height: 77, width: 300 }}></img>
								<Text style={{ color: '#2F4858', fontSize: 14, fontWeight: 500 }}>
									{t('bank.newConnected')}
								</Text>
							</div>

							<div
								style={{
									width: '100%',
									justifyContent: 'center',
									display: 'flex',
									marginBottom: 24
								}}>
								<Card
									className="gb-card-banks-onboarding"
									style={{ width: 960, marginBottom: -40, height: 64, marginTop: 24 }}>
									<div style={{ display: 'flex' }}>
										<img src={psd2} alt="psd2" style={{ height: 48, width: 48 }}></img>
										<div style={{ marginLeft: 8 }}>
											<div
												style={{ color: '#2F4858', fontSize: 14, fontWeight: 400 }}
												dangerouslySetInnerHTML={{
													__html: t('banks.newInfoOnboarding')
												}}></div>
										</div>
									</div>
								</Card>
							</div>
						</>
					)}
					{platform !== 'sabadell' && isMobileOnly && (
						<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
							<img src={gifBank} alt="asdf" style={{ height: 72, width: 300 }}></img>
							<Text style={{ color: '#2F4858', fontSize: 14, fontWeight: 500 }}>
								{t('Conectando con tu banco...')}
							</Text>
						</div>
					)}
					{platform !== 'sabadell' && isMobileOnly && (
						<div
							style={{
								width: '100%',
								justifyContent: 'center',
								display: 'flex',
								marginBottom: 24
							}}>
							<Card className="gb-card-banks-onboarding" style={{ marginTop: 24 }}>
								<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
									<img src={psd2} alt="psd2" style={{ height: 48, width: 48 }}></img>
									<div style={{ marginLeft: 8 }}>
										<div
											style={{ color: '#2F4858', fontSize: 14, fontWeight: 400 }}
											dangerouslySetInnerHTML={{
												__html: t('banks.newInfoOnboarding')
											}}></div>
									</div>
								</div>
							</Card>
						</div>
					)}
					<Afterbanks type={'mortgage'} nameOwner={owner} env={env} />

					{platform !== 'sabadell' && !isMobileOnly && (
						<div style={{ width: '100%', marginBottom: 24, marginTop: 10 }}>
							<img src={footerGibobs} alt="footerGibobs" style={{ width: '100%' }}></img>
						</div>
					)}
					{platform !== 'sabadell' && isMobileOnly && (
						<div style={{ width: '100%', marginBottom: 24, marginTop: 10 }}>
							<img
								src={footerMobileDocs}
								alt="footerMobileDocs"
								style={{ width: '90%', height: '10%' }}></img>
						</div>
					)}

					<Button
						className="button-secundary-gibobs"
						style={{ marginRight: 8, marginTop: 5 }}
						type="dashed"
						onClick={() => {
							checkNextStep();
						}}>
						{t('modalDocuments2.bottonNo')}
					</Button>
					{(fileAfterbanks?.length >= 2 || owner !== 'owner1') && (
						<Button
							onClick={() => {
								setAfterBanksVisible(false);
								setStagesAfterBanks(3);
							}}
							className="button-primari-gibobs"
							style={{ width: 200 }}
							type="primary">
							{t('init.continueButton')}
						</Button>
					)}
				</div>
			)}
			{stages === 3 && platform !== 'sabadell' && stagesAfterBanks === 3 && (
				<div style={{ marginBottom: 200 }}>
					<div
						style={{ marginBottom: -5 }}
						className="need-documents-title"
						dangerouslySetInnerHTML={{
							__html: t('doc.moreBankStatementsDescription')
						}}
					/>
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<img
							src={platform === 'sabadell' ? dataPhotos : dataMoreBanks}
							alt="dataMoreBanks"
							height={isMobileOnly ? 200 : 300}
						/>
					</div>

					{!isMobileOnly && (
						<div>
							<Button
								className="button-secundary-gibobs"
								style={{ marginRight: 8 }}
								type="dashed"
								onClick={() => {
									setAfterBanksVisible(true);
									setStagesAfterBanks(2);
									changeCount();
								}}>
								{t('doc.moreBankStatementsButton')}
							</Button>
							<Button
								onClick={() => {
									clearInterval(myVarAf);
									setThanksVisibleModal(true);
									setAfterBanksVisible(true);
								}}
								className="button-primari-gibobs"
								style={{ width: 200 }}
								type="primary">
								{t('certificated.buttonFinish')}
							</Button>
						</div>
					)}
					{isMobileOnly && (
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<Button
								onClick={() => {
									clearInterval(myVarAf);
									setThanksVisibleModal(true);
									setAfterBanksVisible(true);
								}}
								className="button-primari-gibobs"
								style={{ width: '100%' }}
								type="primary">
								{t('certificated.buttonFinish')}
							</Button>
							<Button
								className="button-secundary-gibobs"
								style={{
									marginRight: 8,
									width: '100%',
									backgroundColor: platform === 'gibobs' ? '#FAFEFE' : '#f5f5f5',
									boxShadow: undefined
								}}
								type="dashed"
								onClick={() => {
									setAfterBanksVisible(true);
									setStagesAfterBanks(2);
									changeCount();
								}}>
								{t('doc.moreBankStatementsButton')}
							</Button>
						</div>
					)}
				</div>
			)} */}

			{/* De momento no mostramos afterbanks en sabadell */}
			{/* {stages === 4 && platform === 'sabadell' && stagesAfterBanks === 1 && (
				<div
					style={{
						margin: '24px auto',
						display: 'flex',
						flexDirection: 'column',
						gap: 24,
						color: '#212121',
						maxWidth: 800
					}}>
					<Text style={{ fontSize: 16, fontWeight: 700 }}>{t('see.bankAccount')}</Text>
					<Space style={{ textAlign: 'left' }}>
						<img src={gibobsLogo} alt="gibobs" style={{ height: 40, width: 'auto' }} />
						<Divider type="vertical" style={{ borderColor: '#424242', margin: 0, height: 40 }} />
						<Text>{t('get.documentedInfo')}</Text>
					</Space>
					<Space
						style={{
							background: '#E1F4FF',
							padding: '8px 16px',
							borderRadius: 8
						}}>
						<img
							src={free}
							alt="ticket"
							style={{ height: 18, width: 'auto', verticalAlign: 'middle' }}
						/>
						<Text style={{ fontSize: 16, fontWeight: 700 }}>{t('service.free')}</Text>
						<Text style={{ fontSize: 16, fontWeight: 500 }}>{t('upload.manually')}</Text>
					</Space>
					<Text style={{ fontSize: 16, fontWeight: 700 }}>{t('few.clicks')}</Text>
					<div style={{ display: 'flex', gap: 40, justifyContent: 'center', marginTop: -18 }}>
						<Space>
							<img src={cursorMagic} style={{ height: 24, width: 'auto' }} />
							Clica en continuar
						</Space>
						<Space>
							<img src={bankIcon} style={{ height: 24, width: 'auto' }} />
							Selecciona tu banco
						</Space>
						<Space>
							<img src={fileIcon} style={{ height: 24, width: 'auto' }} />
							Descarga los estractos
						</Space>
					</div>
					<Space style={{ alignItems: 'start', textAlign: 'left' }}>
						<Checkbox
							onChange={() => setAuthorized(!setAuthorizedBankMov)}
							defaultChecked={authorizedBankMov}
						/>
						<Text>{t('authorize.transferData2')}</Text>
					</Space>
					{!isMobileOnly && (
						<div>
							<Button
								className="button-secundary-gibobs"
								style={{
									backgroundColor: '#f5f5f5',
									boxShadow: undefined,
									width: 200
								}}
								type="dashed"
								onClick={() => {
									setInfo(false);
									setStages(4);
									//callToBankFlip();
								}}>
								{t('upload.later')}
							</Button>
							<Button
								onClick={() => setInfo(false)}
								disabled={!authorized}
								className={'button-primari-gibobs'}
								style={{ paddingLeft: 24, paddingRight: 24, marginLeft: 8, width: 200 }}
								type="primary">
								{t('viability.interest')}
							</Button>
						</div>
					)}
					{isMobileOnly && (
						<div
							style={{
								position: 'fixed',
								bottom: 0,
								left: 0,
								width: '100%',
								padding: '12px 16px',
								zIndex: 1000,
								display: 'flex',
								flexDirection: 'column',
								gap: '8px'
							}}>
							<Button
								className="button-primari-gibobs"
								type="primary"
								onClick={() => setInfo(false)}>
								{t('viability.interest')}
							</Button>
							<Button
								onClick={() => {
									setInfo(false);
									setStages(4);
								}}
								className="button-secundary-gibobs"
								style={{
									border: 'none',
									backgroundColor: '#f5f5f5',
									boxShadow: undefined
								}}
								type="dashed">
								{t('upload.later')}
							</Button>
						</div>
					)}
					<Text style={{ fontSize: 12, color: '#757575', textAlign: 'left' }}>
						{t('download.afterBankTitle6')}
					</Text>
				</div>
			)} */}

			<ErrorAfterbanksModal
				visible={afterBanksVisibleModal}
				errorModal={errorModal}
				onCancel={() => {
					setAfterBanksVisible(true);
					setAfterBanksVisibleModal(false);
					setFileAfterbanks(false);
					setStagesAfterBanks(2);
				}} //Reintentar
				onCreate={() => {
					setAfterBanksVisible(false);
					setAfterBanksVisibleModal(false);
					setFileAfterbanks(false);
					checkNextStep();
					clearInformation();
				}} //Finalizar
			/>

			<ModalManyThanksDocumentation
				visible={thanksVisibleModal}
				owner={owner}
				numParticipants={participants}
				onCreate={() => {
					checkNextStep();
					clearInformation();
					setThanksVisibleModal(false);
				}} //Continue
			/>

			{nameOperations && openModals && (
				<ModalsDni
					env={env}
					userMortgageId={operationId}
					setOpenModals={() => setOpenModals(false)}
					setStages={() => {
						setOpenModals(false);
						setStages(platform === 'sabadell' ? 3 : 2);
						callToBankFlip();
					}}
					platform={platform}
					traceSadabdell={traceSadabdell}
				/>
			)}
		</div>
	);
};
